import React, { useRef, useState, useEffect } from 'react';

import { TiDownload } from 'react-icons/ti';

import {
  Container,
  Delete,
  BillExplanation,
  OpenOrders,
  CloseOrders,
  PaymentTable,
  DisplayNoneImprimir,
} from './styles';

import formatPhone from '~/services/formatPhoneString';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import toast from 'react-hot-toast';
import PrintBillsIndividual from '~/components/Prints/PrintBillsIndividual';
import { useAuth } from '~/context/AuthContext';
import ReactToPrint from 'react-to-print';

export default function OrdersBill({ session, bills }) {
  const { user } = useAuth();
  const [pendingBills, setPendingBills] = useState([]);
  const [closedBills, setClosedBills] = useState([]);

  const componentRef = useRef(null);

  useEffect(() => {
    try {
      const pending = bills.filter((bill) => bill.status !== 'finished');
      setPendingBills(pending);

      const closed = bills.filter((bill) => bill.status === 'finished');
      setClosedBills(closed);
    } catch (error) {}
  }, [bills]);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };
  return (
    <Container>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <BillExplanation>
        <h5>Clientes da Comanda</h5>
      </BillExplanation>
      <OpenOrders>
        <h6>
          <strong>Clientes na Mesa</strong>
        </h6>
        <PaymentTable borderless>
          <tbody>
            {pendingBills.length > 0 ? (
              pendingBills.map((bill) => {
                const userName = bill.buyer
                  ? formatPhone(bill.buyer.phone) || bill.buyer.name
                  : bill.waiter.name;

                return (
                  <tr key={bill.id}>
                    <td>{userName}</td>
                    <td>R${bill.total_service_price}</td>

                    <Delete>
                      <TiDownload
                        onClick={() => {
                          handleFetchDataToPrint({
                            print_type: 'individual_bill',
                            individual_bill_id: bill.id,
                          });
                        }}
                        size={25}
                      />
                    </Delete>
                  </tr>
                );
              })
            ) : (
              <p>Nenhum cliente restante!</p>
            )}
          </tbody>
        </PaymentTable>
      </OpenOrders>
      <CloseOrders>
        <h6>
          <strong>Contas Individuais Fechadas</strong>
        </h6>

        <PaymentTable borderless>
          <tbody>
            {closedBills.length > 0 ? (
              closedBills.map((bill) => {
                const userName = bill.buyer
                  ? formatPhone(bill.buyer.phone)
                  : bill.waiter.name;
                return (
                  <tr key={bill.id}>
                    <td>{userName}</td>
                    <td>R${bill.total_service_price}</td>
                  </tr>
                );
              })
            ) : (
              <p>Nenhuma conta fechada</p>
            )}
          </tbody>
        </PaymentTable>
      </CloseOrders>
    </Container>
  );
}
